import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "language-manager",
  "aria-labelledby": "language-manager-title"
}
const _hoisted_2 = { class: "language-header" }
const _hoisted_3 = ["aria-busy"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "download-error",
  role: "alert"
}
const _hoisted_7 = {
  key: 1,
  class: "download-notice",
  role: "status"
}
const _hoisted_8 = { class: "language-card" }
const _hoisted_9 = { class: "table-toolbar" }
const _hoisted_10 = {
  class: "search-field",
  for: "language-text-search"
}
const _hoisted_11 = {
  class: "language-field",
  for: "language-column-select"
}
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "table-count" }
const _hoisted_15 = {
  class: "table-scroll",
  tabindex: "0",
  role: "region",
  "aria-label": "多语言文本表格，可横向滚动查看所有语言"
}
const _hoisted_16 = { class: "visually-hidden" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "translation-value"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["colspan"]

import { computed, onBeforeUnmount, ref } from "vue";
import { createOss } from "@/utils/oss";
import StudioSelectField from "./StudioSelectField.vue";
import multilingualTextData from "./multilingualTextData.json";


export default /*@__PURE__*/_defineComponent({
  __name: 'MultilingualTextManager',
  setup(__props) {

const search = ref("");
const selectedLanguage = ref("");
const downloading = ref<string | null>(null);
const downloadError = ref("");
const downloadNotice = ref("");
const oss = createOss("DSFGStudio/SaveI18nFile", "https://oss.xiaomol444.xyz/ugc-tool-data");
const languages = multilingualTextData.headers.slice(2);
const columns = computed(() => multilingualTextData.headers
  .map((label, index) => ({ label, index }))
  .filter(column => column.index < 2 || !selectedLanguage.value || column.label === selectedLanguage.value));
const rows = computed(() => {
  const query = search.value.trim().toLocaleLowerCase();
  return multilingualTextData.rows.filter(row => !query || row.some(value => value.toLocaleLowerCase().includes(query)));
});
let downloadController: AbortController | null = null;

async function downloadLanguageFile(filename: "AllLanguage.csv" | "ChineseLanguage.csv") {
  if (downloading.value) return;
  downloading.value = filename;
  downloadError.value = "";
  downloadNotice.value = "";
  const controller = new AbortController();
  downloadController = controller;
  try {
    const response = await fetch(oss.path(filename), { signal: controller.signal });
    if (!response.ok) throw new Error(`文件下载失败（${response.status}），请稍后重试。`);
    const blob = await response.blob();
    if (controller.signal.aborted) return;
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    try {
      link.click();
      downloadNotice.value = `已开始下载 ${filename}。`;
    } finally {
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  } catch (reason) {
    if (!controller.signal.aborted) {
      downloadError.value = reason instanceof Error && reason.message.startsWith("文件下载失败")
        ? reason.message : "无法下载语言文件，请检查网络后重试。";
    }
  } finally {
    if (downloadController === controller) downloadController = null;
    downloading.value = null;
  }
}

onBeforeUnmount(() => downloadController?.abort());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("h2", { id: "language-manager-title" }, "多语言文本管理"),
        _createElementVNode("p", null, "查看对话与任务文本，下载语言文件。")
      ], -1)),
      _createElementVNode("div", {
        class: "download-actions",
        "aria-busy": !!downloading.value
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "primary",
          disabled: !!downloading.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadLanguageFile('AllLanguage.csv')))
        }, _toDisplayString(downloading.value === 'AllLanguage.csv' ? '下载中…' : '下载所有语言文件'), 9, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          disabled: !!downloading.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadLanguageFile('ChineseLanguage.csv')))
        }, _toDisplayString(downloading.value === 'ChineseLanguage.csv' ? '下载中…' : '仅下载简体中文语言文件'), 9, _hoisted_5)
      ], 8, _hoisted_3)
    ]),
    (downloadError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(downloadError.value), 1))
      : _createCommentVNode("", true),
    (downloadNotice.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(downloadNotice.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "搜索文本", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "language-text-search",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
            type: "search",
            placeholder: "搜索文本映射 ID 或任意语言文本",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, search.value]
          ])
        ]),
        _createElementVNode("label", _hoisted_11, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "显示语言", -1)),
          _createVNode(StudioSelectField, {
            id: "language-column-select",
            modelValue: selectedLanguage.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedLanguage).value = $event)),
            "aria-label": "显示语言"
          }, {
            default: _withCtx(() => [
              _createElementVNode("option", _hoisted_12, "全部语言（" + _toDisplayString(_unref(languages).length) + " 种）", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: language,
                  value: language
                }, _toDisplayString(language), 9, _hoisted_13))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("p", _hoisted_14, _toDisplayString(rows.value.length) + " / " + _toDisplayString(_unref(multilingualTextData).rows.length) + " 条文本", 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("table", null, [
          _createElementVNode("caption", _hoisted_16, "多语言文本，共 " + _toDisplayString(_unref(multilingualTextData).rows.length) + " 条文本、" + _toDisplayString(_unref(languages).length) + " 种语言。", 1),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: column.index,
                  scope: "col",
                  class: _normalizeClass({ 'mapping-id': column.index === 0, 'translation-flag': column.index === 1 })
                }, _toDisplayString(column.label), 3))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row[0]
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: column.index,
                    class: _normalizeClass({ 'mapping-id': column.index === 0, 'translation-flag': column.index === 1 })
                  }, [
                    (column.index === 0)
                      ? (_openBlock(), _createElementBlock("code", _hoisted_17, _toDisplayString(row[column.index]), 1))
                      : (column.index === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(row[column.index]), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.index]), 1)
                          ], 64))
                  ], 2))
                }), 128))
              ]))
            }), 128)),
            (!rows.value.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", {
                    colspan: columns.value.length,
                    class: "empty-result"
                  }, "未找到匹配的文本，请尝试其他关键词。", 8, _hoisted_20)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})